import React from 'react'

import { Field } from 'formik'

import { KeyEventUtil } from 'utils'

import { Form, Col } from '_zari/core'

const FechaFinFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const onKeyDown = React.useCallback(e => {
    KeyEventUtil.leaveOnEnterOrTab('button-reporteCobranzas-submit', e)
  }, [])

  return (
    <Form.Group>
      <Form.Label text='FECHA FIN' htmlFor='date-reporteCobranzas-fechaFin' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='fechaFin'>
          {({ field }) => (
            <Form.InputDate
              {...field}
              id='date-reporteCobranzas-fechaFin'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              onKeyDown={onKeyDown}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(FechaFinFormGroup)
